import { FC, useMemo, useState } from 'react';
import { ControllableApplicationRouter } from '@cld/application-router';
import { useAdminSessionTermination } from '@cld/session-service';
import { SnackbarProvider } from '@cld/snackbar';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useApplicationWrapper } from './hooks/useApplicationWrapper';
import { loadMessages } from './i18n';
import { NotFoundPage } from './components/NotFound/NotFound.js';
import {
  AppId,
  ApplicationWrapperConnected,
  CUSTOMER_ID_PREFIX_FOR_URL,
  ApplicationWrapperLanguageProvider,
} from '@cld-remote/application_wrapper/index';
import { StandaloneAccountSettings, SideBarMenu } from './settings.js';
import { UnicornApi } from '@cld/unicorn-api';
import { useAppContext } from './context/App.context.js';

interface AccountSettingsProps {
  unicornApi: UnicornApi;
}

export const AccountSettings: FC<AccountSettingsProps> = ({ unicornApi }) => {
  useAdminSessionTermination();
  const { isMobile } = useAppContext();
  const routerUserData = useMemo(() => ({}), []);
  const { SideMenu, PrimaryMenu, WorkspaceMenu } = useApplicationWrapper(isMobile);
  const { productEnvironment } = unicornApi.data;
  const [isFullScreen, setIsFullScreen] = useState(false);

  return (
    <ApplicationWrapperLanguageProvider loadAppMessages={loadMessages}>
      <ControllableApplicationRouter
        currentCustomer={{ externalIdForUrl: `/c-${productEnvironment.externalId}` }}
        userData={routerUserData}
        customerIdPrefixForUrl={CUSTOMER_ID_PREFIX_FOR_URL}
        notFoundComponent={<NotFoundPage />}
      >
        <ApplicationWrapperConnected
          unicornApi={unicornApi}
          isMobile={isMobile}
          selectedAppId={AppId.Settings}
          primaryMenu={!isFullScreen && <PrimaryMenu />}
          sideBarMenu={
            !isFullScreen && (
              <SideMenu header={<WorkspaceMenu />}>
                <SideBarMenu />
              </SideMenu>
            )
          }
        >
          <SnackbarProvider>
            <StandaloneAccountSettings unicornApi={unicornApi} setIsFullScreen={setIsFullScreen} />
          </SnackbarProvider>
        </ApplicationWrapperConnected>
      </ControllableApplicationRouter>
    </ApplicationWrapperLanguageProvider>
  );
};
